import React from "react";
import Check from "@mui/icons-material/Check";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import "../assets_/timeline.css";

const Timeline = ({ roadmap }) => {
  // Group roadmap data by rdv_name
  const groupedRoadmap = roadmap.reduce((acc, item) => {
    const rdvName = item.rdv_name === "Psy" ? "Psychologue" : item.rdv_name; // Treat "Psy" as "Psychologue"

    if (!acc[rdvName]) {
      acc[rdvName] = [];
    }
    acc[rdvName].push(item);
    return acc;
  }, {});

  const formatTime = (time) => {
    if (!time) return ""; // Handle undefined/null
    const [hours, minutes] = time.split(":"); // Split time by colon
    return `${hours}:${minutes}`; // Return only hours and minutes
  };

  const formatDate = (date) => {
    if (!date) return ""; // Handle undefined/null
    const [year, month, day] = date.split("-"); // Split date by dashes
    return `${day}-${month}-${year}`; // Rearrange to day-month-year
  };

  // Map through grouped data
  return (
    <div className="timeline-container">
      {Object.entries(groupedRoadmap).map(([rdvName, items], index) => (
        <div className="single-timeline-area" key={index}>
          <div
            className={`timeline-date wow fadeInLeft  ${
              rdvName === "Assistant Sociale"
                ? "assis"
                : rdvName === "Psychologue"
                ? "psychologue"
                : rdvName === "Medecin"
                ? "medecin"
                : ""
            }`}
            data-wow-delay="0.1s"
            style={{
              visibility: "visible",
              animationDelay: "0.1s",
              animationName: "fadeInLeft",
            }}
          >
            <p>{rdvName}</p>
          </div>
          <div className="row">
            {items.map((item) => (
              <div className="col-12 col-md-6 col-lg-4" key={item.id}>
                <div
                  className={`single-timeline-content d-flex wow fadeInLeft ${
                    item.rdv_name === "Assistant Sociale"
                      ? "assis"
                      : item.rdv_name === "Psychologue" ||
                        item.rdv_name === "Psy"
                      ? "psychologue"
                      : item.rdv_name === "Medecin"
                      ? "medecin"
                      : "other"
                  }`}
                  data-wow-delay="0.3s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.3s",
                    animationName: "fadeInLeft",
                  }}
                >
                  <div
                    className={`timeline-icon ${
                      item.rdv_name === "Assistant Sociale"
                        ? "assis"
                        : item.rdv_name === "Psychologue" ||
                          item.rdv_name === "Psy"
                        ? "psychologue"
                        : item.rdv_name === "Medecin"
                        ? "medecin"
                        : "other"
                    }`}
                  >
                    {" "}
                    <Check
                      style={{ fontSize: "20px" }}
                      className="text-white"
                    />{" "}
                  </div>
                  <div className="timeline-text">
                    <div className="d-flex justify-content-between">
                      <h6 className="me-5">{formatDate(item.date)}</h6>
                      <p className="fw-bold">
                        {formatTime(item.startTime)} -{" "}
                        {formatTime(item.endTime)}
                      </p>
                    </div>
                    <p
                      className="fw-bold title"
                      style={{ color: "rgb(5, 44, 101)" }}
                    >
                      {["Medecin", "Psychologue"].includes(item.rdv_name)
                        ? "Dr. "
                        : ""}
                      {item?.employe?.nom} {item?.employe?.prenom || item.rdv_name}
                    </p>
                    <span
                      className={`badge ${
                        item.status === "finish"
                          ? "badge-success"
                          : "badge-warning"
                      }`}
                    >
                      <CheckCircleOutline
                        style={{ fontSize: "15px" }}
                        className="mb-1"
                      />
                      {item.status === "finish" ? "Terminé" : "En attente"}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
